import { EnvVariable } from "../models/Environment";
import { KrakendCollection, PagedResults } from "../models/generics";
import client from "./axios";

const environmentsUrl = `${window.__env.KRAKEND_URL}/v1/environmentVariables`;
//const environmentsUrl = 'http://localhost:3000/environments';

export const EnvironmentVariables = {
  getEnvironmentVariables: (params?: URLSearchParams) => client.get<PagedResults<EnvVariable> | KrakendCollection<EnvVariable>>(environmentsUrl, { params }),
  getEnvironmentVariable: (id: string) => client.get<EnvVariable>(`${environmentsUrl}/${id}`),
  createEnvironmentVariable: (environment: EnvVariable) => client.post<EnvVariable>(`${environmentsUrl}`, environment),
  updateEnvironmentVariable: (id: number, environment: EnvVariable) => client.put<EnvVariable>(`${environmentsUrl}/${id}`, environment),
  deleteEnvironmentVariable: (id: number) => client.delete(`${environmentsUrl}/${id}`),
}